<template>
  <div class="flyout-cart" :aria-hidden="isOpen ? 'false' : 'true'">
    <header class="flyout-cart-header">
      <h3 class="flyout-cart-header-title">
        {{ translations.yourCart }}
      </h3>

      <button
        class="flyout-cart-close"
        :aria-label="translations.closeCart"
        @click="toggleOpen(false)"
      >
        <svg aria-hidden="true" class="icon-close" viewBox="0 0 20 20">
          <path
            d="M10 8.586l-7.071-7.071-1.414 1.414 7.071 7.071-7.071 7.071 1.414 1.414 7.071-7.071 7.071 7.071 1.414-1.414-7.071-7.071 7.071-7.071-1.414-1.414-7.071 7.071z"
          />
        </svg>
      </button>
    </header>

    <div class="flyout-cart-line-items">
      <LineItem
        v-for="item in items"
        :key="item.key"
        v-bind="item"
        :money-format="moneyFormat"
        :translations="translations.lineItem"
        @update="updateItem({ item, quantity: $event })"
        @remove="removeItem({ item })"
      />

      <span v-if="isEmpty" class="flyout-cart-empty">
        {{ translations.isEmpty }}
      </span>
    </div>

    <footer class="flyout-cart-footer">
      <div class="flyout-cart-footer-table-row">
        <span class="flyout-cart-footer-table-row-text">
          {{ translations.subTotal }}
        </span>
        <span class="flyout-cart-footer-table-row-figure">
          {{ formattedSubTotal }}
        </span>
      </div>
      <span class="flyout-cart-footer-small-text">
        {{ translations.subTotalSmallPrint }}
      </span>
      <button class="flyout-cart-button button-primary" @click="checkout">
        {{ translations.checkout }}
      </button>
    </footer>
  </div>
</template>

<script>
import $ from 'jquery';
import * as ShopifyCurrency from '@shopify/theme-currency';

import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import { flyoutCart, actions, mutations } from './store';

import { createRechargeCheckoutURL } from '../../helpers/recharge';

import LineItem from './LineItem.vue';

export default {
  name: 'FlyoutCart',

  components: {
    LineItem
  },

  props: {
    moneyFormat: {
      type: String
    },
    translationsJson: {
      type: String
    },
    shopDomain: {
      type: String
    },
    customerEmail: {
      type: String,
      default: ''
    },
    customerId: {
      type: String,
      default: ''
    }
  },

  computed: {
    ...mapState(flyoutCart, [
      'isOpen',
      'token',
      'items',
      'itemCount',
      'subTotal'
    ]),

    ...mapGetters(flyoutCart, ['isEmpty', 'hasSubscriptionItems']),

    translations() {
      return JSON.parse(this.translationsJson);
    },

    formattedSubTotal() {
      return ShopifyCurrency.formatMoney(this.subTotal, this.moneyFormat);
    }
  },

  mounted() {
    const $body = $(document.body);
    const $document = $(document);

    this.fetchState();

    // Event sent from modified Empire code
    document.addEventListener('addToCartButton.click', (e) => {
      const {
        variantId,
        quantity,
        sellingPlanId
      } = e.detail;

      this.addItem({
        variantId: parseInt(variantId),
        quantity,
        sellingPlanId
      });
    });
    
    // If we click on the overlay, it should close
    $body.on('click', 'pxl-flyout-cart', (e) => {
      if (e.target.tagName === 'PXL-FLYOUT-CART') {
        this.toggleOpen(false);
      }
    });

    $document.keydown((e) => {
      // Esc key pressed
      if (this.isOpen && e.keyCode === 27) {
        this.toggleOpen(false);
      }
    });

    if (window.location.hash.includes('open_cart')) {
      this.toggleOpen(true);
    }
  },

  methods: {
    checkout() {
      if (!this.isEmpty) {
        const checkoutUrl = this.hasSubscriptionItems
          ? createRechargeCheckoutURL(
              this.customerId,
              this.customerEmail,
              this.token,
              this.shopDomain
            )
          : '/checkout';

        window.location = checkoutUrl;
      }
    },

    ...mapMutations({
      toggleOpen: `${flyoutCart}/${mutations.TOGGLE_OPEN}`
    }),

    ...mapActions({
      addItem: `${flyoutCart}/${actions.addItem}`,
      fetchState: `${flyoutCart}/${actions.fetchState}`,
      updateItem: `${flyoutCart}/${actions.updateItem}`,
      removeItem: `${flyoutCart}/${actions.removeItem}`
    })
  }
};
</script>
